import { jsxs as a, jsx as s } from "react/jsx-runtime";
import r from "./alert-banner.module.less.js";
const c = (e) => {
  switch (e) {
    case "neutral":
      return "dark-blue";
    case "important":
      return null;
    default:
      return null;
  }
}, i = (e) => {
  switch (e) {
    case "important":
      return "ui-icon-error";
    case "neutral":
    default:
      return "ui-icon-info";
  }
}, m = ({ content: e, levelOfUrgency: t = "neutral" }) => {
  const n = c(t), o = i(t);
  return /* @__PURE__ */ a("div", { className: `${r.wrapper} ${r[t]} ${n ? "theme-" + n : ""}`, children: [
    /* @__PURE__ */ s("span", { className: `${r.icon} ${o}` }),
    /* @__PURE__ */ s("div", { className: [r.content, "body-s mb-0"].join(" "), children: e })
  ] });
};
export {
  m as default
};
